export default {"src":"/_next/static/image/public/images/ic_blue_rightarrow.6a815bedbcbccf2d64cf17a1970b81a9.svg","height":24,"width":24};